// extracted by mini-css-extract-plugin
export default {"box":"styles_box__rUoNU","glitch":"styles_glitch__u92UN","enterLink":"styles_enterLink__kbb5S"};